import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { COVER_CARRY_RETURN_TO } from './publicCoverPath';

/**
 * The sign-up or the sign-in link of the public tool (design g1, g4). It comes back to the page
 * that puts the carried design on a song (`returnTo`). With an email, the sign-up form opens with
 * it filled in. The address is under `/app`. Pure.
 */
export function coverSignUpHref(options: { email?: string | null; signIn?: boolean } = {}): string {
  const query = new URLSearchParams({ returnTo: COVER_CARRY_RETURN_TO });
  if (options.email !== undefined && options.email !== null && options.email !== '') {
    query.set('email', options.email);
  }
  if (options.signIn === true) {
    query.set('mode', 'signin');
  }
  return `/app/${SMLRouteNames.auth}?${query.toString()}`;
}
